import Buttons from './Buttons.js'
var sb = require('@sb/util')
var Drag = require('../views/dragscroll.js')

export default {
	props: ['ev'],

	watch: {
		ev (ev) {
			this.$nextTick(() => this.bindDrag())
		},
	},
	mounted () {
		this.bindDrag()
	},

	render () {
		// dont support user sent button yet
		let byType = sb.get(this.ev, 'by.type')
		if (byType === 'user') return null

		// filter out all generic
		let attachments = sb.get(this.ev, 'data.message.attachments', [])
		let generics = sb.filter(attachments, att => sb.get(att, 'type') === 'generic')

		if (generics.length === 0) return null
		var $generics = sb.map(generics, (gen, index) => {
			var $eles = sb.map(gen.elements, ele => {
				let $title = ele.title ? <div class="generic-attachment--element-title">{ele.title}</div> : null
				let $subtitle = ele.subtitle ? <div class="generic-attachment--element-subtitle">{ele.subtitle}</div> : null

				return (
					<div class="generic-attachment--element">
						<div>
						<img class="generic-attachment--element-img" src={sb.replaceFileUrl(ele.image_url)} />
						</div>
						{$title}
						{$subtitle}
						<Buttons buttons={ele.buttons} />
					</div>
				)
			})

			return (
				<div class="generic-attachment-container">
					<div ref={'template_' + index} class="generic-attachment">
						{$eles}
					</div>
				</div>
			)
		})

		return $generics
	},

	methods: {
		bindDrag () {
			sb.map(this.$refs, (ref, k) => {
				if (!k.startsWith('template_')) return
				Drag(ref, () => {})
			})
		},
	},
}
